export class ToastManager {
    private static instance: ToastManager
    private _showToast?: (message: string, severity?: string, autoHideInSeconds?: number) => void

    private constructor() {}

    public static shared(): ToastManager {
        if (!ToastManager.instance) {
            ToastManager.instance = new ToastManager()
        }
        return ToastManager.instance
    }

    public setCallback(callback: (message: string, severity?: string, autoHideInSeconds?: number) => void) {
        this._showToast = callback
    }

    private show(message: string, severity: 'success' | 'error' | 'warning' | 'info' = 'info', autoHideInSeconds?: number) {
        this._showToast?.(message, severity, autoHideInSeconds)
    }

    public showSuccessMessage(message: string) {
        this.show(message, 'success')
    }

    public showErrorMessage(message: string) {
        this.show(message, 'error', 60)
    }

    public showWarningMessage(message: string) {
        this.show(message, 'warning')
    }

    public showInfoMessage(message: string) {
        this.show(message, 'info')
    }
}